import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { LOCALSTORAGE_LOCATIONPERMISSION } from "../../const/storage"
import "./WelcomeModal.css"

export default function WelcomeModal({ onAllow, onAsk, onDeny }) {
    const navigate = useNavigate()

    useEffect(() => {
        const dialog = document.getElementById("welcomeDetails")
        if (dialog && !dialog.open) {
            dialog.showModal()
        }
    }, [])

    const handleLearnMore = () => {
        const dialog = document.getElementById("welcomeDetails")
        if (dialog) {
            dialog.close()
        }
        localStorage.setItem(LOCALSTORAGE_LOCATIONPERMISSION, "ask")
        navigate("/privacy")
    }

    const handleAllow = () => {
        const dialog = document.getElementById("welcomeDetails")
        if (dialog) {
            dialog.close()
        }
        onAllow()
    }

    const handleAsk = () => {
        const dialog = document.getElementById("welcomeDetails")
        if (dialog) {
            dialog.close()
        }
        onAsk()
    }

    const handleDeny = () => {
        const dialog = document.getElementById("welcomeDetails")
        if (dialog) {
            dialog.close()
        }
        onDeny()
    }

    return (
        <dialog id="welcomeDetails" className="ps-4 pe-4">
            <img
                src={`/image/world-map-red-pins-greyscale.png`}
                className="card-img-top welcome-modal-image"
                alt="World Map"
            />
            <h5 className="card-title welcome-modal-title">
                Welcome to Chaperon
            </h5>

            <p className="card-text welcome-modal-text">
                We're here to help you stay informed about the safety of the
                people and places you care about.
                <br />
                <br />
                In a moment, we'll be asking for{" "}
                <strong>your permission</strong> to access{" "}
                <strong>your location</strong> data, so that we can:
                <br />
            </p>

            <ul className="welcome-modal-list">
                <li>Show you safety information relevant to your location</li>
                <li>
                    Provide real-time notifications about nearby safety concerns
                </li>
                <li>Keep your authorized community informed</li>
            </ul>

            <p className="card-text welcome-modal-text">
                We take <strong>your privacy</strong> seriously and so it is
                important to us to give you a heads up about the request, as
                well as why we're making the request.
            </p>

            <p className="card-text welcome-modal-privacy-text">
                Your location data is only used to enhance your experience and
                is never shared with unauthorized third parties. You can change
                this permission at any time in your browser settings.
            </p>

            <hr className="welcome-modal-divider" />

            <div className="welcome-modal-footer">
                <button
                    className="btn btn-link text-decoration-none"
                    onClick={handleLearnMore}
                >
                    Learn More
                </button>
                <button className="btn btn-outline-danger" onClick={handleDeny}>
                    Deny Access
                </button>
                <button className="btn btn-outline-primary" onClick={handleAsk}>
                    Ask Again
                </button>
                <button
                    className="btn btn-primary"
                    autoFocus
                    onClick={handleAllow}
                >
                    Allow Location Access
                </button>
            </div>
        </dialog>
    )
}
